import gql from "graphql-tag";

export default gql`
  mutation UpdateCustomer(
    $id: ID!
    $name: String
    $address: String
    $email: String
    $phoneNumber: String
  ) {
    updateCustomer(
      id: $id
      name: $name
      address: $address
      email: $email
      phoneNumber: $phoneNumber
    ) {
      id
    }
  }
`;



// WEBPACK FOOTER //
// ./src/GraphQL/Mutations/UpdateCustomer.ts